import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

import { EcmMaterialModule } from '@ecm/material';
import { Role } from '@ecm/portfolio';
import { EcmRouterModule, Link, LinkService, ToggleService, TrackingData } from '@ecm/router';

import { TelcoStateEnum } from '../../../../business/api/contract/telcoState.enum';
import { ActiveContractViewModel } from '../../../../business/model/crossroads/contracts-options/active-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { CrossroadsViewModel } from '../../../../business/model/crossroads/crossroads.view-model';
import { TypeContractEnum } from '../../../../business/model/crossroads/typeContractEnum';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';

@Component({
    selector: 'other-contracts',
    templateUrl: 'other-contracts.html',
    standalone: true,
    imports: [EcmMaterialModule, AsyncPipe, EcmRouterModule, TranslateModule],
})
export class OtherContractsComponent implements OnInit {
    @Input()
    public viewModel: CrossroadsViewModel;

    public addContractData: any;

    public removeContractLink: Link;

    public addContractLink: Link;

    public canDisplayRemoveContractButton = false;

    public constructor(
        private readonly translate: TranslateService,
        private readonly linkService: LinkService,
        private readonly toggleService: ToggleService,
    ) {
        translate.use('fr');
    }

    public ngOnInit(): void {
        this.canDisplayRemoveContractButton = this.canRemoveContract();

        this.toggleService
            .getFeatureStatus('DASHBOARD.ADD_CONTRACT_ECM')
            .pipe(take(1))
            .subscribe((ecmAddContractStatus) => {
                const manageContract = this.translate.instant('dashboard.contractsAndOptions.manageContract');
                this.removeContractLink = manageContract['removeContract.link'];
                this.addContractData = this.viewModel.isVimEligible
                    ? manageContract.vimContract
                    : manageContract.addContract;
                this.addContractLink = this.viewModel.isVimEligible
                    ? manageContract.vimContract.link
                    : ecmAddContractStatus
                      ? manageContract.addContract.ecmLink
                      : manageContract.addContract.link;
            });
    }

    /**
     * check if user can remove contract. If he can it return true to display button
     * @return {boolean}
     */
    public canRemoveContract(): boolean {
        const activeContracts: ContractsViewModel[] = this.viewModel.contracts.filter(
            (contract) => contract.typeContract === TypeContractEnum.ACTIVE,
        );
        const isHolderContracts: ActiveContractViewModel[] = [];
        activeContracts.forEach((activeContract: ContractsViewModel) => {
            const contract: ActiveContractViewModel = activeContract.contract as ActiveContractViewModel;
            if (
                (contract.state === TelcoStateEnum.LOGGED &&
                    (contract.role.toUpperCase() === Role.GESTIONNAIRE ||
                        contract.role.toUpperCase() === Role.UTILISATEUR)) ||
                contract.state === TelcoStateEnum.HELD ||
                contract.state === TelcoStateEnum.DELEGATED
            ) {
                isHolderContracts.push(contract);
            }
        });
        return isHolderContracts.length > 0;
    }

    public addContract(): void {
        this.linkService.openLink(
            this.addContractLink,
            Object.assign(new TrackingData(), {
                tmsTracking: {
                    trackedPage: TrackedPage.contractsAndOptions,
                    trackingArea: 'care_selecteurcontrat_ajoutcontrat',
                    trackingName: this.addContractData.button,
                },
            }),
        );
    }

    /**
     * Route to remove contract page
     */
    public removeContract(): void {
        this.translate
            .get('dashboard.contractsAndOptions.manageContract.removeContract')
            .subscribe((removeContractData: any) => {
                this.linkService.openLink(
                    removeContractData['link'],
                    Object.assign(new TrackingData(), {
                        tmsTracking: {
                            trackedPage: TrackedPage.contractsAndOptions,
                            trackingArea: 'care_selecteurcontrat_retraitcontrat',
                            trackingName: removeContractData['button'],
                        },
                    }),
                );
            });
    }
}
